import $md5 from 'js-md5';
import Config from '../config';

export function getHeader(url, code) {
  let timestamp = new Date() * 1;
  let token = sessionStorage.getItem(Config.tokenName) === null ? "" : sessionStorage.getItem(Config.tokenName);
  let source = 'web';
  let sign = $md5(source + url + code + timestamp + token);
  return { 'Content-Type': 'application/json;charset=UTF-8', 'applyToken': token, 'timestmp': timestamp, 'sign': sign, 'code': code, 'source': source };
}



// WEBPACK FOOTER //
// ./src/api/header.js